import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import { GET_DEBITED, GET_WALLET, GET_WALLET_GRAPH } from "../constants";

export const getWallet = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `wallet?type=2&index=${data.index}&size=20&added_type=${data.added_type}&search=${data.searchtext}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_WALLET,
        walletlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getDebited = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `wallet?type=1&index=${data.index}&size=20&added_type=${data.added_type}&search=${data.searchtext}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_DEBITED,
        debitlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getWalletGrapth =
  (start_date, end_date, type, tab) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `wallet?type=${tab == 1 ? 4 : 3
        }&index=0&size=100&start_date=${start_date}&end_date=${end_date}&graph_type=${type}`
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_WALLET_GRAPH,
          getwalletgraphdata: response?.data?.response,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };
